export default __webpack_public_path__ + "static/media/goshen39.5c81d8e6.jpg";